import instantsearch from 'instantsearch.js';

import algoliasearch from "algoliasearch";
import { configure } from 'instantsearch.js/es/widgets';
import { connectAutocomplete, connectSearchBox } from 'instantsearch.js/es/connectors';

const MIN_QUERY_LENGTH = 3;
const DEBOUNCE_MS = 300;

export class HeaderSearch {

	constructor() {
		this.started = false;
		this.debounceTimer = null;
	}

	init(){
		const input = document.querySelector('#header-searchInput');
		const container = document.querySelector('#header-autocomplete');
		if (!input || !container) {
			return;
		}

		const start = () => this.startOnce(input, container);
		input.addEventListener('focus', start);
		input.addEventListener('input', start);
	}

	startOnce(input, container) {
		if (this.started) {
			return;
		}
		this.started = true;

		const headerSearch = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX+'fullsite',
			searchClient: algoliasearch(
			  'LTCGWA12RB',
			  'fbbd5f8b545361104df6b21dfd244cc1'
			),
			routing: false,
			searchFunction(helper) {
				const query = (helper.state.query || '').trim();
				if (query.length >= MIN_QUERY_LENGTH) {
					helper.search();
				}
			},
		});

		const renderIndexListItem = ({ indexId, hits }) => `
			<ul class="search-suggestions">
			${hits
			  .map(
				(hit, hitIndex) =>
					` <li class="search-item">
				  		<a href="/?s=${encodeURIComponent(hit.title)}">${instantsearch.highlight({ attribute: 'title', hit })}</a>
					</li>
				  `
			  )
			  .join('')}
			</ul>
	  `;

		const renderAutocomplete = (renderOptions, isFirstRender) => {
			const { indices, currentRefinement, refine, widgetParams } = renderOptions;

			if (isFirstRender) {
			  const ul = document.createElement('ul');
			  const existing = input.value.trim();
			  if (existing.length >= MIN_QUERY_LENGTH) {
				refine(input.value);
			  }

			  input.addEventListener('input', event => {
				const value = event.currentTarget.value;
				clearTimeout(this.debounceTimer);
				this.debounceTimer = setTimeout(() => {
					if (value.trim().length >= MIN_QUERY_LENGTH) {
						refine(value);
					} else {
						ul.innerHTML = '';
						refine('');
					}
				}, DEBOUNCE_MS);
			  });

			  widgetParams.container.appendChild(ul);
			}

			const list = widgetParams.container.querySelector('ul');
			if (!list) {
				return;
			}
			if ((currentRefinement || '').trim().length < MIN_QUERY_LENGTH) {
				list.innerHTML = '';
				return;
			}
			list.innerHTML = indices
			  .map(renderIndexListItem)
			  .join('');
		};

		const customAutocomplete = connectAutocomplete(
			renderAutocomplete
		);

		const virtualSearchBox = connectSearchBox(() => {});

		headerSearch.addWidgets([
			virtualSearchBox({}),
			configure({
				hitsPerPage: 5,
			}),
			customAutocomplete({
				container,
			})
		]);

		headerSearch.start();
	}

}
